module.exports = __webpack_public_path__ + "img/lingbolive_logo_name@3x.4c82a593.png";